import Header from "../header/Header";
import Sidebar from "../sidebar/Sidebar";

interface MainProps {
  children: React.ReactNode;
}

const Main: React.FC<MainProps> = ({ children }) => {
  return (
    <div className="layout-wrapper">
      <Sidebar />
      <div className="main-content-wrapper">
        <div className="main-grid-container">
          <Header />
          <div className="k-container">
            <div className="gx-main-content">
              <main>{children}</main>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
